export default {
  lang: {
    label: 'Language',
    en: 'English',
    ru: 'Русский',
  },
  nav: {
    dashboard: 'Dashboard',
    partners: 'Partners',
    import: 'Price list import',
    catalog: 'Catalog',
    specifications: 'Specifications',
    purchaseOrders: 'Purchase orders',
    storefront: 'Storefront preview',
    settings: 'Settings',
    feedback: 'Feedback',
    operations: 'Operations',
    channel: 'Channel',
  },
  shell: {
    hub: 'Partner Hub',
    searchPlaceholder: 'Search articles, partners',
    newSpec: 'New specification',
    admin: 'Admin',
    footer: 'Treejar Trading LLC · Dubai, UAE · Internal partner platform',
    prices: 'Prices in AED · Data refreshed 23 Oct 2026, 09:40',
    openNav: 'Open navigation',
    notifications: 'Notifications',
    staleTitle: '{{count}} price lists are stale',
    staleBody: 'Two dealers have not refreshed prices in over a week.',
    reviewPartners: 'Review partners',
  },
  common: {
    reset: 'Reset',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    search: 'Search',
    add: 'Add',
    edit: 'Edit',
    all: 'All',
    view: 'View',
    open: 'Open',
    back: 'Back',
    status: 'Status',
    actions: 'Actions',
    included: 'Included',
    units: 'units',
    items: 'items',
    days: 'days',
    weeks: 'weeks',
    weekShort: 'wks',
    stock: 'Stock',
    category: 'Category',
    price: 'Price',
    cost: 'Cost',
    sale: 'Sale',
    margin: 'Margin',
    of: 'of',
    aed: 'AED',
    vatNoteCosts: 'Costs include partner discount · sale prices exclude 5% VAT',
    snapshot: 'Snapshot 23 Oct 2026 09:40',
  },
  status: {
    ReadyForPickup: 'Ready for pickup',
    PartiallyPickedUp: 'Partially received',
    PickedUp: 'Received',
    Closed: 'Closed',
    Cancelled: 'Cancelled',
    Active: 'Active',
    Paused: 'Paused',
    Negotiating: 'Negotiating',
    Onboarding: 'Onboarding',
    Draft: 'Draft',
    New: 'New',
    Sent: 'Sent',
    Signed: 'Signed',
    Expired: 'Expired',
    Confirmed: 'Confirmed',
    'Picked up': 'Picked up',
    Delivered: 'Delivered',
    Published: 'Published',
    Superseded: 'Superseded',
    Quoted: 'Quoted',
    Won: 'Won',
    Lost: 'Lost',
    Verified: 'Verified',
    Allowed: 'Allowed',
    Blocked: 'Blocked',
    Fresh: 'Fresh',
    'Special only': 'Special only',
    Latest: 'Latest',
    Invited: 'Invited',
    Live: 'Live',
    Hidden: 'Hidden',
    'Own stock': 'Own stock',
    Partner: 'Partner',
    'Own warehouse': 'Own warehouse',
  },
  category: {
    workstations: 'Workstations',
    desks: 'Office desks',
    chairs: 'Seating',
    storage: 'Storage',
    components: 'Components',
    meetingTables: 'Meeting tables',
    softSeating: 'Soft seating',
    pedestals: 'Pedestals',
    execDesks: 'Executive desks',
    partitions: 'Partitions & screens',
    reception: 'Reception',
    coffeeTables: 'Coffee tables',
    services: 'Services',
  },
  dashboard: {
    eyebrow: 'Friday, 23 October 2026',
    title: 'Partner operations overview',
    description: 'Shared catalog health, inbound partner stock and purchase orders across the Dubai dealer network.',
    importBtn: 'Import price list',
    manageBtn: 'Manage partners',
    staleCount: '{{count}} price lists are older than 7 days.',
    staleBody: '{{names}} may be quoting outdated partner prices.',
    review: 'Review partners',
    kpiActive: 'Active partners',
    kpiActiveHint: 'of {{count}} in network',
    kpiSkus: 'Partner articles',
    kpiUnits: 'Units in partner stock',
    kpiValue: 'Stock value at cost',
    kpiStale: 'Stale price lists',
    kpiStaleHint: 'action needed',
    liveSnapshot: 'live snapshot',
    addedOct: '1 added in Oct',
    weekChange: '+7 this week',
    resaleTrend: '-312 resale',
    shareTrend: '2.4%',
    overSeven: '> 7 days old',
    freshnessTitle: 'Partners and price list freshness',
    freshnessSub: 'Last accepted price list per dealer. Rows older than 7 days are flagged.',
    viewAll: 'View all',
    colPartner: 'Partner',
    colSkus: 'Articles',
    colUnits: 'Units',
    colDiscount: 'Discount',
    colLast: 'Last update',
    contractGate: 'Contract gating: {{can}} of {{total}} partners can publish',
    importNew: 'Import new list',
    incomingTitle: 'Incoming stock',
    incomingSub: 'Next 3 weeks from partners',
    openCatalog: 'Open catalog',
    recentPo: 'Recent purchase orders',
    allPo: 'All POs',
    staleBadge: '{{days}}d stale',
  },
  partners: {
    eyebrow: 'Network',
    title: 'Partners',
    description: 'Dubai and Northern Emirates dealers supplying stock Treejar does not hold. Contracts gate what can be published.',
    addPartner: 'Add partner',
    importList: 'Import list',
    statNetwork: 'Partners in network',
    statSkus: 'Partner articles',
    statUnits: 'Units available',
    statDiscount: 'Avg. dealer discount',
    ofNetwork: 'of {{count}} dealers in the market',
    searchPlaceholder: 'Search partner or contact',
    colPartner: 'Partner',
    colContact: 'Contact',
    colPhone: 'Phone',
    colSkus: 'Articles',
    colUnits: 'Units in stock',
    colDiscount: 'Discount',
    colLast: 'Last price list',
    colStatus: 'Status',
    stale: 'stale',
    empty: 'No partners match this filter.',
    footer: '{{shown}} of {{total}} partners · catalog value at cost {{value}}',
    footerNote: 'Partner prices exclude VAT · updated daily at 09:30',
    addTitle: 'Add partner',
    addSub: 'Invite a dealer to the shared catalog.',
    company: 'Company name',
    contactName: 'Contact name',
    whatsapp: 'WhatsApp number',
    warehouse: 'Warehouse address',
    create: 'Create partner',
    inviteToast: 'Invitation prepared for the new partner',
    inviteDetail: 'Track the contract status from the partner profile.',
    cabinet: 'Cabinet',
  },
  pd: {
    back: 'Partners',
    notFound: 'Partner not found',
    backToPartners: 'Back to partners',
    contract: 'Contract {{status}}',
    message: 'Message',
    newPriceList: 'New price list',
    pause: 'Pause partner',
    resume: 'Resume partner',
    pauseToast: 'Partner paused — storefront listings hidden',
    resumeToast: 'Partner resumed — products can be quoted again',
    openCabinet: 'Open partner cabinet',
    tabOverview: 'Overview',
    tabTerms: 'Terms',
    tabContract: 'Contract',
    tabLists: 'Price lists',
    tabSources: 'Data sources',
    tabProducts: 'Articles',
    tabWebOrders: 'Web orders',
    uploadDocuments: 'Upload documents',
    statSkus: 'Articles in catalog',
    statUnits: 'Units in stock',
    statDiscount: 'Agreed discount',
    statLast: 'Last price list',
    daysAgo: '{{days}}d ago',
    termsSaved: 'Partner terms updated',
  },
  ov: {
    company: 'Company',
    companySub: 'Legal and trading details held on file',
    tradingName: 'Trading name',
    contact: 'Primary contact',
    phone: 'Phone / WhatsApp',
    email: 'Email',
    emirate: 'Emirate',
    since: 'Partner since',
    payment: 'Payment terms',
    vat: 'VAT registration',
    warehouse: 'Warehouse',
    pickupOnly: 'Pickup only',
    deliveryAvailable: 'Delivery available',
    directions: 'Directions',
    notes: 'Notes',
    notesSub: 'Internal only — never shown on the storefront',
    snapshot: 'Commercial snapshot',
    discount: 'Discount on price list',
    special: 'Special items discount',
    notDiscounted: 'Not discounted',
    discounted: 'Discounted',
    catalogValue: 'Catalog value at cost',
    reservation: 'Reservation window',
    minResale: 'Minimum resale rule',
    rating: 'Partner rating',
    latestList: 'Latest price list',
    noList: 'No list uploaded',
    import: 'Import',
    compliance: 'Compliance',
    contract: 'Contract',
    licence: 'Trade licence',
    publishing: 'Storefront publishing',
    daysOld: '{{days}} days old',
    spend: 'Spend since 2023',
  },
  terms: {
    title: 'Commercial terms',
    sub: 'Applied to every imported price list for this partner unless a row overrides it.',
    discount: 'Discount on partner price',
    payment: 'Payment terms',
    reservation: 'Reservation period',
    minResale: 'Minimum resale price rule',
    specialLabel: 'Special offer items: no discount',
    specialDesc: 'Rows flagged as special offer keep the partner price as cost, regardless of the agreed discount.',
    delivery: 'Delivery or pickup',
    deliveryOpt: 'Delivery',
    pickupOpt: 'Pickup',
    pickupNote: 'Treejar arranges transport. Pickup cost is added to the purchase order as a separate line.',
    deliveryNote: 'Partner delivers to site. Minimum order value and trip charges apply as stated in the contract.',
    save: 'Save terms',
    guardTitle: 'Resale guardrails',
    guardSub: 'Rules enforced in the catalog and specification builder',
    guard1: 'Sale price can never fall below the minimum resale rule, even during project discounting.',
    guard2: 'Special offer rows are excluded from automated discounting and flagged in the specification builder.',
    guard3: 'Publishing to the storefront requires a signed contract on this partner.',
    preview: 'Pricing preview',
    previewSub: 'Live calculation with the terms above',
    partnerPrice: 'Partner price',
    cost: 'Cost to Treejar',
    markup: 'Typical markup 40%',
    suggested: 'Suggested sale',
    example: 'Example uses CH-229A High back mesh chair. Discount applies before markup; surcharges are added after.',
    log: 'Change log',
  },
  ct: {
    title: 'Reseller agreement',
    signed: 'Prepared by Treejar, signed by both parties. Articles from this partner can be published to the storefront.',
    expired: 'Agreement expired on 31 Aug 2026. Publishing is blocked until the contract is renewed.',
    pending: 'Agreement sent to the partner and awaiting signature. Publishing is blocked until signed.',
    storefront: 'Storefront',
    document: 'Contract document',
    documentSub: 'Prepared by Treejar legal, version 3',
    download: 'Download contract',
    preview: 'Preview',
    start: 'Contract start',
    end: 'Contract end',
    signedByTreejar: 'Signed by Treejar',
    signedByPartner: 'Signed by partner',
    law: 'Governing law',
    notice: 'Notice period',
    rule: 'Publishing rule',
    ruleSub: 'What the contract unlocks in the storefront',
    allowed: 'Allowed with a signed contract',
    allowed1: 'Publish articles to treejartrading.ae',
    allowed2: 'Add partner stock to client specifications',
    allowed3: 'Issue purchase orders',
    blocked: 'Blocked',
    blocked1: 'New storefront publications',
    blocked2: 'Price list imports accepted',
    blocked3: 'Discount application',
    actions: 'Actions',
    send: 'Send for signature',
    resend: 'Resend for signature',
    renew: 'Start renewal',
    privacy: 'Contract files are stored privately and are only visible to admins and partner managers.',
    history: 'Contract history',
    sentTo: 'Signature request sent to {{name}}',
    downloaded: 'Contract PDF downloaded',
    noFile: 'No contract has been created for this partner yet — prepare it in Onboarding',
    downloadFailed: 'Could not download the contract PDF',
    previewFailed: 'Could not open the contract PDF',
    openedToast: 'Contract preview opened',
    renewToast: 'Renewal draft created — valid 12 months from 01 Nov 2026',
  },
  lists: {
    current: 'Current version',
    itemsLatest: 'Articles in latest list',
    uploads: 'Uploads this year',
    daysSince: 'Days since update',
    history: 'Upload history',
    historySub: 'Every accepted import creates a new immutable version. Suppliers are not notified automatically.',
    upload: 'Upload',
    colVersion: 'Version',
    colDate: 'Date',
    colItems: 'Articles',
    colChanges: 'Changes',
    colBy: 'Uploaded by',
    colStatus: 'Status',
    empty: 'No price lists uploaded yet.',
    footer: 'Version {{version}} is live in the catalog · older versions kept for audit',
  },
  pp: {
    warning: 'Contract is {{status}}, so these articles cannot be published to the storefront. They can still be added to internal specifications.',
    title: '{{count}} articles from {{name}}',
    sub: 'Partner identity is hidden on the storefront; partner price is internal only.',
    openCatalog: 'Open catalog',
    colItem: 'Article',
    colCategory: 'Category',
    colStock: 'Stock',
    colPartnerPrice: 'Partner price',
    colCost: 'Cost',
    colSale: 'Sale',
    colMargin: 'Margin',
    colStorefront: 'Storefront',
    footer: 'Publishing uses Treejar branding. Partner names, partner prices and discounts never appear on the storefront.',
  },
  cabinet: {
    back: 'Partner',
    title: 'Partner cabinet',
    subtitle: 'Articles, logistics data and price agreement for {{name}}. This is the same view the dealer sees when they sign in.',
    access: 'Cabinet access',
    portalEmail: 'Portal login',
    portalUsers: 'Active users',
    lastLogin: 'Last sign-in',
    inviteUser: 'Invite user',
    inviteSent: 'Cabinet invitation sent to the partner',
    kpiArticles: 'Articles in cabinet',
    kpiUnits: 'Units available',
    kpiValue: 'Stock value at cost',
    kpiShare: 'Share of partner spend',
    kpiSpend: 'Spend since 2023',
    articles: 'Articles',
    articlesSub: 'Every article with commercial and logistics data. Click a row to open the full product card.',
    colArticle: 'Treejar SKU',
    colSupplier: 'Supplier article',
    colName: 'Name',
    colCategory: 'Category',
    colWeight: 'Weight',
    colDims: 'Dimensions, mm',
    colCbm: 'CBM',
    colPacking: 'Packing',
    colStock: 'Stock',
    colPartnerPrice: 'Partner price',
    colDiscount: 'Disc.',
    colCost: 'Cost',
    colSale: 'Sale',
    colMargin: 'Margin',
    colLead: 'Lead time',
    colStatus: 'Status',
    addArticle: 'Add article',
    addTitle: 'New article',
    addSub: 'Add a product to this partner cabinet with its weights and logistics data.',
    fName: 'Article name',
    fSku: 'Supplier article',
    fCategory: 'Category',
    fWeight: 'Weight, kg',
    fDims: 'Dimensions W×D×H, mm',
    fCbm: 'CBM per unit',
    fPacking: 'Packing',
    fPrice: 'Partner price, AED',
    fStock: 'Stock now',
    fLead: 'Lead time',
    create: 'Save article',
    created: 'Article {{sku}} saved to the cabinet',
    noArticles: 'No articles yet — import a price list or add one manually.',
    logistics: 'Logistics',
    logisticsSub: 'Defaults applied to every shipment from this dealer.',
    warehouse: 'Warehouse address',
    deliveryMode: 'Delivery mode',
    leadTime: 'Standard lead time',
    incoterm: 'Incoterm',
    minOrder: 'Minimum order',
    origin: 'Country of origin',
    payment: 'Payment terms',
    reservation: 'Reservation window',
    pickup: 'Pickup by Treejar',
    delivery: 'Partner delivery',
    pricing: 'Pricing agreement',
    pricingSub: 'Discount is applied to the partner price before markup.',
    markup: 'Applied markup',
    saleFormula: 'Sale price = cost × (1 + markup) + option surcharges',
    documents: 'Documents',
    contract: 'Reseller agreement',
    priceList: 'Current price list',
    expires: 'Valid until {{date}}',
    openProduct: 'Open',
    summary: 'Cabinet summary',
  },
  catalog: {
    eyebrow: 'Catalog',
    title: 'Sellable stock across own warehouse and partners',
    description: 'Every item here is costed with the partner discount already applied. Partner names stay internal.',
    importPrices: 'Import prices',
    buildSpec: 'Build specification',
    itemsCount: '{{count}} items',
    split: '{{partner}} partner · {{own}} own',
    filters: 'Filters',
    search: 'Search',
    searchPlaceholder: 'SKU or product name',
    source: 'Source',
    own: 'Own',
    partner: 'Partner',
    allPartners: 'All partners',
    category: 'Category',
    allCategories: 'All categories',
    availability: 'Availability',
    inStockOnly: 'In stock only',
    inStockHint: 'Hides items with 0 units now',
    priceRange: 'Sale price',
    colour: 'Colour',
    baseType: 'Base type',
    sortMargin: 'Best margin',
    sortPriceLow: 'Price low to high',
    sortPriceHigh: 'Price high to low',
    sortStock: 'Stock volume',
    sortSku: 'SKU',
    grid: 'Grid view',
    table: 'Table view',
    emptyTitle: 'No products match these filters',
    emptyBody: 'Try widening the price range or clearing the colour filter.',
    resetFilters: 'Reset filters',
    footerNote: '{{count}} active partners · partner names never appear on the storefront',
    colItem: 'Item',
    colCategory: 'Category',
    colSource: 'Source',
    colStock: 'Stock',
    colCost: 'Cost',
    colSale: 'Sale',
    colMargin: 'Margin',
    colStorefront: 'Storefront',
    inStock: '{{count}} in stock',
    incoming: '0 · {{qty}} incoming',
    marginPct: '{{value}}% margin',
    costLabel: 'Cost {{value}}',
  },
  product: {
    back: 'Catalog',
    notFound: 'Product not found',
    backToCatalog: 'Back to catalog',
    viewSpecs: 'View specifications',
    addToSpec: 'Add to specification',
    inStock: '{{count}} in stock',
    incoming: '0 now · {{qty}} in 2 weeks',
    special: 'Special offer · no discount',
    colour: 'Colour',
    base: 'Base',
    packing: 'Packing',
    cbm: 'CBM per unit',
    stockGroup: 'Stock group',
    shipsFrom: 'Ships from',
    treejarWarehouse: 'Treejar warehouse, Al Quoz',
    partnerWarehouse: 'Partner warehouse',
    stockPosition: 'Stock position',
    totalUnits: '{{count}} units total',
    nowUnits: 'Now {{count}}',
    arriving: '{{qty}} by {{date}}',
    noInbound: 'No inbound',
    specsTitle: 'Specifications',
    optionsTitle: 'Available options',
    swatches: 'Fabric swatches',
    supplyTitle: 'Supply source',
    internalOnly: 'internal only',
    partner: 'Partner',
    contract: 'Contract',
    lastList: 'Last price list',
    reservation: 'Reservation',
    openPartner: 'Open partner',
    pricingTitle: 'Pricing',
    partnerPrice: 'Partner price',
    discount: 'Discount {{value}}',
    cost: 'Cost to Treejar',
    markup: 'Markup',
    salePrice: 'Sale price',
    marginAed: 'Margin AED',
    marginPct: 'Margin %',
    minResale: 'Minimum resale rule: {{rule}}. Surcharges added after markup.',
    storefront: 'Storefront',
    publishLabel: 'Publish to storefront',
    publishDesc: 'Shown with Treejar branding, sale price and availability label.',
    previewListing: 'Preview listing',
    usedIn: 'Used in specifications',
    notUsedYet: 'Not used in any specification yet.',
    siteSales: 'Sales on treejartrading.ae',
    siteSalesNone: 'No sales reported by the site yet.',
    siteSales30d: 'Last 30 days',
    siteSalesRevenue30d: 'Site revenue, 30 days',
    siteSalesTotal: 'All time',
    siteSalesLast: 'Last sale',
    siteSalesUnitsOrders: '{{units}} pcs · {{orders}} orders',
    addTitle: 'Add to specification',
    specification: 'Specification',
    quantity: 'Quantity',
    availableNow: '{{count}} available now from {{source}}',
    arrivingNote: '0 available now · {{qty}} arriving {{date}}',
    addLine: 'Add line',
    added: 'Added {{qty}} × {{sku}} to {{spec}}',
    publishBlocked: 'Cannot publish — {{partner}} contract is {{status}}',
    publishedToast: 'Published to treejartrading.ae',
    hiddenToast: 'Hidden from the storefront',
    logisticsTitle: 'Logistics & weight',
    logisticsSub: 'Used for freight quotes, packing lists and delivery slots.',
    weight: 'Gross weight',
    dims: 'Dimensions (W×D×H)',
    leadTime: 'Lead time',
    origin: 'Country of origin',
    incoterm: 'Incoterm',
    hsCode: 'HS code',
    minOrder: 'Minimum order',
    supplierArticle: 'Supplier article',
    unitsPerCarton: 'Units per carton',
    carton: 'Pcs / carton',
    noPartner: 'Own stock',
    cubeNote: 'CBM is calculated per packed unit and drives the delivery cost estimate.',
    markupSaved: 'Markup saved — site price recalculated',
    noCbm: 'no CBM',
    lotKind: { old_stock: 'Old stock', new_stock: 'New stock', incoming: 'Incoming' },
    reservationDays: '{{count}} days',
    oldStockPrice: 'Old-stock price',
    markupAuto: 'By rule · {{value}}%',
    markupSource: {
      product: 'Markup set on this item (overrides rules).',
      partner_category: 'Rule for this partner and category.',
      partner_rule: 'Rule for this partner.',
      category: 'Rule for this category.',
      partner: 'Partner default markup.',
      default: 'Workspace default markup.',
    },
    manualSite: 'Manual site price',
    minResaleRule: {
      none: 'none',
      partner_price: 'not below partner price',
      markup_over_cost: 'not below cost + {{value}}% ({{price}})',
      per_sku: 'per SKU: {{price}}',
    },
    openOnSite: 'Open on site',
    noOpenSpecs: 'No open specifications — create one first',
    newSpecLink: 'New specification',
  },
  imp: {
    eyebrow: 'Price list import',
    title: 'Turn a partner price list into catalog stock',
    description: 'Upload the dealer file, let the extractor map every row, correct the uncertain cells, then publish a new version that flows straight into specifications.',
    history: 'Import history',
    newImport: 'New import',
    step1: 'Upload',
    step1Hint: 'PDF, Excel or photos',
    step2: 'AI extraction',
    step2Hint: '30 pages',
    step3: 'Review items',
    step3Hint: '148 rows',
    step4: 'Version diff',
    step4Hint: 'Publish',
    doneTitle: 'Version {{version}} is live',
    doneBody: '{{count}} items from {{partner}} are now in the catalog. 2 new items, 1 removal and 7 price or stock changes were applied. Specifications quoted before today keep their original prices.',
    statItemsLive: 'Items live',
    statPriceCuts: 'Price cuts',
    statPriceRises: 'Price rises',
    statStorefront: 'Storefront',
    updated: 'Updated',
    openCatalog: 'Open catalog',
    viewPartner: 'View partner',
    importAnother: 'Import another',
    toastTitle: 'Version {{version}} published — {{count}} items updated',
    toastDetail: 'Partner manager notified. Catalog prices are now current.',
  },
  impUpload: {
    title: 'Upload the partner price list',
    sub: 'Drag a file here or browse. Scanned pages and phone photos are accepted — the extractor reads tables, stock notes and option surcharges.',
    dropTitle: 'Drop price list here',
    dropSub: 'PDF, XLSX, CSV, JPG or PNG · up to 40 MB',
    browse: 'Browse files',
    fileMeta: '{{size}} · {{pages}} pages detected',
    remove: 'Remove file',
    lookTitle: 'What the extractor looks for',
    look1Title: 'Prices and discounts',
    look1Text: 'List price, old stock price, special offer flags.',
    look2Title: 'Stock and incoming',
    look2Text: 'Units now, inbound quantity and ETA per SKU.',
    look3Title: 'Options',
    look3Text: 'Base type, armrest and fabric surcharges.',
    look4Title: 'Shared stock pools',
    look4Text: 'Items that draw from the same physical stock.',
    settingsTitle: 'Import settings',
    partner: 'Partner',
    contractStatus: 'Contract status',
    contractSigned: 'Signed · valid to 31 Oct 2026',
    notify: 'Notify partner manager when the new version is published',
    merge: 'Merge duplicate SKUs automatically and flag conflicts',
    start: 'Start AI extraction',
    prevTitle: 'Previous version',
    prevMeta: 'v11 · 07 Oct 2026',
    prevItems: '141 items',
    prevBody: 'The new list will be diffed against v11 before publishing. Nothing goes live until you confirm.',
    formats: 'Formats',
  },
  impExtract: {
    titleRun: 'Extracting tables and stock notes',
    titleDone: 'Extraction complete',
    meta: '{{file}} · {{pages}} pages · partner {{partner}}',
    pageOf: 'Page {{page}} of {{total}}',
    complete: 'Complete',
    progressLine: 'Page {{page}} of {{total}} — {{items}} items found',
    extracted: '{{count}} items extracted',
    statItems: 'Items found',
    statTables: 'Tables read',
    statDuplicates: 'Duplicates merged',
    statUnreadable: 'Unreadable cells',
    pause: 'Pause',
    resume: 'Resume',
    skip: 'Skip to results',
    logTitle: 'Page log',
    logSub: 'Each row is a page of the source document.',
    page: 'Page {{page}}',
    queued: 'Queued',
    items: '{{count}} items',
    reading: 'Reading…',
    sourceTitle: 'Source preview',
    region: 'Page {{page}} · table region',
    sourceNote: 'Low-resolution scans are read with a layout model; every cell keeps a link back to its source page.',
    rulesTitle: 'Review rules',
    rule1: 'High confidence rows publish as-is',
    rule2: 'Check rows need a quick click',
    rule3: 'Low rows are highlighted and block publish',
    review: 'Review {{count}} items',
    backUpload: 'Back to upload',
    note: 'Nothing is written to the catalog until you publish in the final step.',
  },
  impReview: {
    banner1: '{{count}} duplicates merged',
    banner2: '{{count}} items share stock pools',
    bannerRest: 'Stock is counted once per pool so specifications never double-book units.',
    showLow: 'Show low confidence',
    showAll: 'Show all rows',
    title: 'Review extracted items',
    draft: 'v{{version}} draft',
    sub: 'Click any highlighted cell to correct it. Yellow rows need attention before publishing.',
    all: 'All',
    high: 'High',
    check: 'Check',
    low: 'Low',
    searchPlaceholder: 'Search SKU, name or colour',
    searchAria: 'Search extracted rows',
    lowRows: '{{count}} low confidence rows',
    rowsShown: '{{shown}} of {{total}} rows shown',
    selected: '{{count}} selected',
    colItem: 'Item',
    colCategory: 'Category',
    colColour: 'Colour',
    colStockNow: 'Stock now',
    colIncoming: 'Incoming',
    colPartnerPrice: 'Partner price',
    colOldPrice: 'Old-stock price',
    colOptions: 'Options / surcharges',
    colStockGroup: 'Stock group',
    colPacking: 'Packing',
    colConfidence: 'Confidence',
    merged: 'merged',
    newItem: 'new',
    selectAll: 'Select all rows',
    selectRow: 'Select {{sku}}',
    back: 'Back',
    compare: 'Compare with v{{version}}',
    footer: 'Showing {{shown}} of {{total}} extracted rows · {{pages}} pages processed',
  },
  impDiff: {
    statNew: 'New items',
    statRemoved: 'Removed items',
    statPrice: 'Price changes',
    statStock: 'Stock changes',
    typeNew: 'New item',
    typeRemoved: 'Removed',
    typePrice: 'Price change',
    typeStock: 'Stock change',
    title: 'Changes against v{{version}}',
    sub: '07 Oct 2026 · 141 items → today · {{count}} items. Only differences are listed.',
    allChanges: 'All changes',
    colChange: 'Change',
    colSku: 'SKU',
    colItem: 'Item',
    colValues: 'Before → after',
    removedValue: 'removed',
    empty: 'No changes of this type.',
    publishTitle: 'Publish {{count}} items as v{{version}}',
    publishSub: 'Price and stock updates replace v{{version}}. Existing specifications keep their quoted prices.',
    back: 'Back',
    publishBtn: 'Publish {{count}} items',
    confirmTitle: 'Publish version {{version}}?',
    confirmBody: '{{count}} items from {{partner}} become the live catalog version. Previous prices are archived for audit.',
    confirmCheck: 'Push visible items to the storefront preview at the same time',
    cancel: 'Cancel',
    publishNow: 'Publish now',
  },
  spec: {
    eyebrow: 'Specifications',
    title: 'Client specifications',
    description: 'Build project furniture lists from own stock and partner stock. Stock warnings appear as soon as quantities exceed availability.',
    browseCatalog: 'Browse catalog',
    newSpec: 'New specification',
    openProjects: 'Open projects',
    pipelineSale: 'Pipeline at sale',
    projectedMargin: 'Projected margin',
    stockRiskLines: 'Lines with stock risk',
    allTitle: 'All specifications',
    sorted: 'Sorted by delivery date',
    colSpec: 'Specification',
    colClient: 'Client',
    colOwner: 'Owner',
    colDelivery: 'Delivery',
    colLines: 'Lines',
    colSale: 'Sale',
    colMargin: 'Margin',
    colStatus: 'Status',
    lineMeta: '{{lines}} items · {{units}} units',
    footer1: '{{count}} specifications · {{lines}} lines total',
    footer2: 'Quoted prices are locked for 14 days from issue',
    needApproval: 'Need approval',
    untitled: 'Untitled project',
    empty: 'No specifications yet. Create one and add items from the catalog.',
  },
  specDetail: {
    back: 'Specifications',
    notFound: 'Specification not found',
    backToSpec: 'Back to specifications',
    owner: 'Owner {{name}}',
    deliveryMeta: '{{client}} · delivery {{date}}',
    saveDraft: 'Save draft',
    createPo: 'Create purchase orders',
    client: 'Client',
    project: 'Project',
    deliveryDate: 'Delivery date',
    linesTitle: 'Line items',
    linesSub: 'Select a line to see alternatives from other partners. Stock warnings block nothing — they flag risk.',
    addItem: 'Add item',
    colItem: 'Item',
    colSource: 'Source',
    colQty: 'Qty',
    colAvailable: 'Available',
    colOption: 'Option',
    colCost: 'Cost',
    colSale: 'Sale',
    colLineMargin: 'Line margin',
    own: 'Own',
    short: 'short {{count}}',
    remove: 'Remove {{sku}}',
    noLines: 'No lines yet. Add items from the catalog.',
    footer: '{{items}} items · {{units}} units · {{risk}} stock risk',
    costLabel: 'Cost',
    saleLabel: 'Sale',
    marginLabel: 'Margin',
    totalsTitle: 'Project totals',
    salePrice: 'Sale price',
    costAtPartner: 'Cost at partner price',
    marginPct: 'Margin %',
    vat: 'VAT 5%',
    totalInclVat: 'Total incl. VAT',
    split: 'Splits {{count}} partners automatically',
    findAlt: 'Find alternatives',
    forLine: 'For {{sku}} · {{category}}',
    selectLine: 'Select a line item',
    inStock: '{{count}} in stock',
    swapIn: 'Swap in',
    noAlt: 'No alternatives in this category from other partners.',
    searchFull: 'Search full catalog',
    riskTitle: 'Stock risk',
    riskLine: '{{sku}} needs {{count}} more units than partner stock',
    riskOk: 'All lines within available stock',
    poTitle: 'Split into purchase orders',
    poSub: '{{id}} · lines are grouped by partner. Own-warehouse lines are not ordered.',
    poLines: '{{count}} lines · {{units}} units',
    poEmpty: 'No partner lines to order.',
    poTotal: 'Total at cost',
    cancel: 'Cancel',
    poCreate: 'Create {{count}} orders',
    toastSwapped: '{{sku}} swapped into the specification',
    toastSaved: 'Specification saved as draft',
    toastCreated: '{{count}} purchase orders created in draft',
  },
  po: {
    eyebrow: 'Purchase orders',
    title: 'Orders to partners',
    description: 'Every PO is tied to a client specification and priced at partner cost. Sending is done by email or WhatsApp.',
    newOrder: 'New order from specification',
    openValue: 'Open order value',
    inProgress: 'Orders in progress',
    deliveredValue: 'Delivered value',
    unitsOnOrder: 'Units on order',
    note: 'Total at cost · prices locked at PO creation',
    colPo: 'PO number',
    colPartner: 'Partner',
    colSpec: 'Specification',
    colLines: 'Lines',
    colTotal: 'Total at cost',
    colCreated: 'Created',
    colStatus: 'Status',
    units: '{{count}} units',
    empty: 'No purchase orders with this status.',
    footer1: '{{shown}} of {{total}} orders',
    footer2: 'Partner reservation windows apply from the moment a PO is confirmed',
  },
  poDetail: {
    back: 'Purchase orders',
    notFound: 'Purchase order not found',
    backToPo: 'Back to purchase orders',
    meta: '{{partner}} · {{spec}} · created {{created}} · required {{expected}}',
    sendEmail: 'Send by email',
    sendWa: 'Send via WhatsApp',
    downloadPdf: 'Download PDF',
    emailed: 'Purchase order emailed to {{partner}}',
    pdfDone: 'PDF generated and downloaded',
    pdfPreview: 'PDF preview',
    pdfMeta: 'Page 1 of 1 · A4',
    company: 'Treejar Trading LLC',
    tagline: 'Office furniture · Dubai, UAE',
    docTitle: 'Purchase order',
    issued: 'Issued {{date}}',
    supplier: 'Supplier',
    supplierAddress1: 'Warehouse No.6, Industrial Area 18',
    supplierAddress2: 'Sharjah, United Arab Emirates',
    deliverTo: 'Deliver to',
    deliverAddress1: 'Emaar Business Park, Tower 3',
    deliverAddress2: 'Floor 12, Sheikh Zayed Road',
    deliverAddress3: 'Dubai, United Arab Emirates',
    attn: 'Attn: site supervisor',
    colSku: 'SKU',
    colDescription: 'Description',
    colQty: 'Qty',
    colUnitCost: 'Unit cost',
    colAmount: 'Amount',
    subtotal: 'Subtotal at cost',
    vat: 'VAT 5% (recoverable)',
    totalInclVat: 'Total incl. VAT',
    termsTitle: 'Terms',
    termsBody: 'Net 30 from delivery. Stock reserved for 48 hours after confirmation. Delivery included within Dubai and Sharjah on orders above AED 2,500.',
    authorisedBy: 'Authorised by',
    authorisedName: 'Layla Hassan',
    authorisedRole: 'Partner manager, Treejar Trading',
    itemsTitle: 'Items ordered',
    itemsMeta: '{{lines}} lines · {{units}} units',
    totalAtCost: 'Total at partner cost',
    statusTitle: 'Order status',
    statusUpdated: 'Status updated to {{status}}',
    timeline1: 'Draft created',
    timeline2: 'Sent to partner',
    timeline3: 'Partner confirmed',
    timeline4: 'Picked up / delivered',
    partnerTitle: 'Partner',
    paymentTerms: 'Payment terms',
    net30: 'Net 30 from delivery',
    reservation: 'Reservation',
    hours48: '48 hours',
    delivery: 'Delivery',
    included: 'Included',
    openPartner: 'Open partner',
    linkedSpec: 'Linked specification',
    linkedNote: 'Selling prices on the specification are unaffected by later partner price list changes.',
    waMessage: 'Hello {{partner}}, this is Treejar Trading. Please confirm purchase order {{po}} for {{lines}} lines ({{units}} units), total AED {{total}} at cost. Delivery requested {{date}}.',
  },
  sf: {
    eyebrow: 'Storefront preview',
    title: 'What clients see on treejartrading.ae',
    description: 'Published items only. Partner names, partner prices and margins are removed — clients see Treejar branding, sale price and availability.',
    previewMode: 'Preview mode',
    openLive: 'Open live site',
    publishChanges: 'Publish changes',
    publishToast: '{{count}} published items snapshot pushed to the live site',
    urlPath: 'treejartrading.ae/office-furniture',
    preview: 'Preview',
    topbar: 'Project pricing within 24 hours · Delivery across the UAE',
    nav1: 'Office furniture',
    nav2: 'Projects',
    nav3: 'About',
    nav4: 'Contact',
    requestQuote: 'Request a quote',
    categoryEyebrow: 'Office furniture',
    heroTitle: 'Task seating and tables, ready to deliver',
    heroSub: 'Contract-grade pieces held in Dubai stock, specified for fit-outs across the Emirates.',
    products: '{{count}} products',
    inStockDubai: 'In stock · Dubai',
    availableIn: 'Available in {{weeks}} weeks',
    from: 'From',
    requestQuoteBtn: 'Request quote',
    showAll: 'Show all {{count}} products',
    noProducts: 'No published products in this category.',
    address: 'Treejar Trading LLC · Al Quoz Industrial 4, Dubai · sales@treejartrading.ae',
    footerNote: 'Prices exclude VAT · Lead times confirmed on quotation',
    previewNote: 'Preview uses live published flags. Changing a product to hidden removes it from this view immediately.',
    rulesTitle: 'Preview rules',
    rule1: 'Only published items with a signed partner contract',
    rule2: 'Sale price and availability label only',
    rule3: 'No partner names, cost prices or margins',
    rule4: 'No stock quantities shown to clients',
    pubTitle: 'Publication status',
    publishedItems: 'Published items',
    hiddenItems: 'Hidden items',
    blockedByContract: 'Blocked by contract',
    blockedNote: 'Emirates Seating contract expired, so its 2 published items are held back.',
    clientActions: 'Client actions',
    clientActionsBody: 'Request quote opens the Treejar enquiry form. Submissions land in the Forms panel and notify the sales inbox.',
  },
  sfQuote: {
    title: 'Request a quote',
    close: 'Close quote form',
    fullName: 'Full name',
    yourName: 'Your name',
    company: 'Company',
    companyPlaceholder: 'Company name',
    email: 'Work email',
    emailPlaceholder: 'you@company.ae',
    quantity: 'Quantity',
    details: 'Project details',
    detailsPlaceholder: 'Delivery location, timeline, finish requirements',
    sending: 'Sending request',
    send: 'Send request',
    note: 'This is a preview of the live form on treejartrading.ae',
    successTitle: 'Request received',
    successBody: 'A Treejar project specialist will reply within one business day with pricing and availability.',
    closeBtn: 'Close',
    errorFallback: 'We could not send your request. Please check the details and try again.',
    errorNetwork: 'Network error — please check your connection and try again.',
  },
  src: {
    webTitle: 'Partner website',
    webSub: 'Parse the dealer catalog from their site — scraped prices and stock are matched against the current price list.',
    urlLabel: 'Catalog URL on their site',
    urlPlaceholder: 'https://partner-site.ae/catalog',
    parse: 'Parse website',
    reparse: 'Parse again',
    progress: 'Pages scanned: {{page}} of {{total}}',
    lastParsed: 'Last parsed {{date}}',
    noSite: 'No website on file — paste a catalog URL to scrape their products.',
    statPages: 'Pages',
    statItems: 'Items',
    statMatched: 'Matched to list',
    statNew: 'New items',
    colItem: 'Item',
    colPrice: 'Price on site',
    colStock: 'Stock',
    colMatch: 'Match',
    matched: 'Matched',
    unmatched: 'Not in list',
    importBtn: 'Add to cabinet',
    importedToast: '{{count}} new items added to the cabinet',
    importedNote: 'Items were saved as drafts — publish them after review.',
    docsTitle: 'Supplier documents',
    docsSub: 'Catalog, price list and contract stay private to your team.',
    kindCatalog: 'Catalog',
    kindPrice: 'Price list',
    kindContract: 'Contract',
    kindCatalogDesc: 'PDF, Excel or photos of the catalog with models and finishes',
    kindPriceDesc: 'Price list with prices, stock and option surcharges',
    kindContractDesc: 'Signed reseller agreement, PDF only',
    upload: 'Upload file',
    processing: 'Processing…',
    ready: 'Ready',
    signed: 'Signed',
    awaitSignature: 'Awaiting signature',
    markSigned: 'Mark as signed',
    signedToast: 'Contract marked as signed — publishing unlocked',
    uploadToast: '{{name}} uploaded and queued for extraction',
    removeDoc: 'Remove {{name}}',
    emptyDocs: 'No documents yet — upload a catalog, price list or contract.',
    docsFoot: 'Files are read by the extractor: specs come from the catalog, prices and stock from the price list.',
    contactTitle: 'Manager contact',
    contactSub: 'Who receives web orders and stock requests',
    fName: 'Name',
    fRole: 'Role',
    fPhone: 'Phone / WhatsApp',
    fEmail: 'Email',
    fHours: 'Working hours',
    fLang: 'Languages',
    saveContacts: 'Save contact',
    contactSaved: 'Manager contact updated',
    contactNote: 'Storefront orders are delivered to this manager by WhatsApp and email. Internal notes stay hidden from the partner.',
    gateTitle: 'Supplier readiness',
    gateSub: 'What is connected for publishing and ordering',
    gateSite: 'Website parsed',
    gateCatalog: 'Catalog uploaded',
    gatePrice: 'Price list uploaded',
    gateContract: 'Contract signed',
    notSet: 'Not set',
    openOrders: 'Web orders',
  },
  wo: {
    title: 'Web orders',
    sub: 'treejartrading.ae items to buy from this partner. Send by WhatsApp or to the manager inbox.',
    kpiNew: 'Awaiting send',
    kpiNewHint: 'new storefront orders',
    kpiUnits: 'Units to order',
    kpiUnitsHint: 'across unsent orders',
    kpiValue: 'Cost value',
    kpiValueHint: 'at partner price',
    kpiSent: 'Sent',
    kpiSentHint: 'in the last 30 days',
    send: 'Send',
    resend: 'Resend',
    sendSelected: 'Send {{count}}',
    colOrder: 'Order',
    colClient: 'Client',
    colItems: 'Partner items',
    colUnits: 'Units',
    colTotal: 'Cost',
    colStatus: 'Status',
    colAction: 'Action',
    selectAll: 'Select all orders',
    selectOrder: 'Select order {{no}}',
    fromSite: 'from treejartrading.ae',
    empty: 'No web orders for this partner yet.',
    foot: 'Only this partner’s lines are included · prices are locked at send time',
    note: 'The client sees Treejar branding and the sale price. The partner receives article numbers, quantities and the delivery address only — never the resale price or client details.',
    modalTitle: 'Send order to partner',
    modalSub: 'Recipient {{name}} · {{count}} orders',
    previewLabel: 'Message to partner',
    msgGreeting: 'Hello {{name}},',
    msgIntro: 'Treejar Trading is sending storefront orders. Please confirm availability and lead time:',
    msgLine: '• {{no}} — {{client}} · {{units}} units · AED {{total}} at cost',
    msgOutro: 'Delivery to Treejar warehouse, Al Quoz. Thank you!',
    sendEmail: 'By email',
    sendWa: 'Via WhatsApp',
    sent: 'Order {{no}} sent to {{name}}',
    sentBulk: '{{count}} orders sent to {{name}}',
  },
  set: {
    eyebrow: 'Settings',
    title: 'Workspace configuration',
    description: 'Commercial rules, team access and how the catalog appears on the client storefront.',
    save: 'Save changes',
    saved: 'Settings saved',
    tabPricing: 'Pricing rules',
    tabUsers: 'Users & roles',
    tabRoles: 'Role permissions',
    tabCosts: 'Costs & approvals',
    tabStorefront: 'Storefront',
    tabFeedback: 'Feedback',
    tabAudit: 'Log',
    rulesTitle: 'Default resale rules',
    rulesSub: 'Applied when a partner price list is published. Individual items can override the markup.',
    markup: 'Default markup',
    rounding: 'Price rounding',
    rounding5: 'Nearest 5 AED',
    rounding10: 'Nearest 10 AED',
    rounding1: 'Nearest 1 AED',
    roundingNone: 'No rounding',
    staleThreshold: 'Stale price list threshold',
    days: 'days',
    minMarginGuard: 'Minimum margin guard',
    guardLabel: 'Block sale prices below the partner minimum resale rule',
    guardDesc: 'Overrides project discounts and manual price edits.',
    mergeLabel: 'Merge duplicate SKUs during price list import',
    mergeDesc: 'Duplicates are combined and flagged in the review step.',
    gateLabel: 'Require a signed contract before publishing partner items',
    gateDesc: 'Blocks storefront publication and new purchase orders for unsigned partners.',
    exampleTitle: 'Example calculation',
    exampleSub: 'CH-229A · partner price AED 305, discount 18%',
    exPartnerPrice: 'Partner price',
    exAfterDiscount: 'After 18% discount',
    exMarkup: 'Markup {{value}}%',
    exRounded: 'Rounded',
    exMargin: 'Margin %',
    roundingNote: 'Rounding: {{rounding}}. Guard blocks anything under {{margin}}% margin.',
    teamTitle: 'Team access',
    teamSub: '5 seats · admins can change roles at any time',
    invite: 'Invite',
    inviteToast: 'Invitation link copied — share it with the new team member',
    colUser: 'User',
    colRole: 'Role',
    colStatus: 'Status',
    colLast: 'Last active',
    roleAdmin: 'Admin',
    rolePartner: 'Partner manager',
    roleProject: 'Project manager',
    roleViewer: 'Viewer',
    roleFinance: 'Finance',
    roleFor: 'Role for {{name}}',
    statusActive: 'Active',
    rolesTitle: 'Role permissions',
    rolesAdminDesc: 'Full access, pricing rules, users, contracts',
    rolesPartnerDesc: 'Partners, price list imports, publishing',
    rolesProjectDesc: 'Specifications, purchase orders, catalog',
    rolesViewerDesc: 'Read-only catalog and specifications',
    rolesFinanceDesc: 'Client and partner payments, Zoho reconciliation',
    displayTitle: 'Client-facing display',
    displaySub: 'Controls what appears on treejartrading.ae.',
    showStockLabel: 'Show exact stock quantities to clients',
    showStockDesc: 'Off by default — clients see an availability label instead of units.',
    approvalLabel: 'Require approval before publishing catalogue changes',
    approvalDesc: 'An admin must approve storefront updates before they go live.',
    leadLabel: 'Lead time label',
    leadNote: 'Use {weeks} as the placeholder for incoming lead time.',
    currency: 'Currency',
    currencyValue: 'AED — UAE Dirham',
    quoteDest: 'Quote form destination',
    quoteDestValue: 'Forms panel · sales inbox',
    previewLabels: 'Preview labels',
    inStockDubai: 'In stock · Dubai',
    labelsNote: 'Partner names, partner prices and cost prices are never rendered on the storefront, regardless of these settings.',
  },
};